// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"8bb610e7","326":"8605697b","331":"36c92e09","472":"55f2e2bf","626":"eaf4457f","787":"0532360a","799":"86ea2ed7"}[chunkId] + ".chunk.js";
};